import './header.scss';

import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import Logo from 'hellosign/components/app/logo-v2';

import UserMenu from 'hellospa/components/user-menu';

const messages = defineMessages({
  openSidebarLabel: {
    id: '',
    description: 'The aria label for a button which opens the sidebar.',
    defaultMessage: 'Open sidebar',
  },
});

class CondorHeader extends React.Component {
  render() {
    const {
      intl,
      user,
      isSidebar,
      isMobile,
      openSidebar,
      isLogoutOnly,
      isUserMenu,
      siteCode,
    } = this.props;

    return (
      <div className="condor-header">
        <div className="container-fluid py-3 py-md-4">
          <div className="row">
            {(isSidebar && isMobile) && (
              <div className="col-4">
                <div className="condor-header__sidebar-open-button"
                  onClick={openSidebar}
                  role="button"
                  aria-label={intl.formatMessage(messages.openSidebarLabel)}
                >
                  <span className="condor-header__sidebar-open" />
                </div>
              </div>
            )}
            {!isSidebar && (
              <div className="col-4 col-md-6">
                <div className="condor-header__logo">
                  <Logo siteCode={siteCode} variant="wordmark" size={40} />
                </div>
              </div>
            )}
            {isUserMenu && (
              <div className={`col-8 col-md-${isSidebar ? '12' : '6'}`}>
                <div className="condor-header__user-menu">
                  <UserMenu user={user} isLogoutOnly={isLogoutOnly} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(CondorHeader);
